import {useSelector} from 'react-redux';
import {EMPTY_LIST} from '../../constants/empty.constants';

/**
 * Connected Open Banking accounts, with a reference-stable empty fallback.
 * @returns {Array<Object>} Open Banking accounts, or a shared empty array.
 */
export const useOpenBankingAccounts = () => useSelector(state => state.openBanking?.accounts ?? EMPTY_LIST);
